module.exports = __webpack_public_path__ + "img/elixir.2bc80272.png";